import {
  LOGOUT_COMPLETED
} from '../../actionTypes/logoutActionTypes';

export const logoutStart = () => ({
  type: LOGOUT_COMPLETED
});

export const logoutUser = () => {
  return (dispatch) => {
    dispatch(logoutStart());
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/LogoutActions/logoutUser.js